import { forwardRef, Ref, SVGAttributes } from 'react';
type Props = SVGAttributes<SVGSVGElement>;
const SendIcon = forwardRef((props: Props, ref: Ref<SVGSVGElement>) => <svg ref={ref} viewBox="0 0 21 21" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M17.15 9.45 3.95 2.06a.63.63 0 0 0-.89.76l2.49 6.97c.05.14.05.29 0 .42l-2.49 6.97a.62.62 0 0 0 .9.76l13.19-7.4a.63.63 0 0 0 0-1.09v0ZM5.63 10h5" />
  </svg>);
export default SendIcon;